// debounce.service.ts
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DelayOnSearchService {
  private subject = new Subject<string>();

  emitValue(value: string) {
    this.subject.next(value);
  }

  onDebounce(delay: number = 1200): Observable<string> {
    return this.subject.asObservable().pipe(
      debounceTime(delay),
      distinctUntilChanged()
    );
  }
}
